"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteGroceryItemMutationOptions = exports.deleteGroceryItemMutation = void 0;
const client_1 = require("@apollo/client");
const groceryItems_1 = require("../queries/groceryItems");
exports.deleteGroceryItemMutation = client_1.gql `
  mutation DeleteGroceryItem($id: String!) {
    deleteGroceryItem(id: $id) {
      ok
    }
  }
`;
exports.deleteGroceryItemMutationOptions = (variables) => ({
    variables,
    update: store => {
        let data = null;
        try {
            data = store.readQuery({
                query: groceryItems_1.groceryItemsQuery,
            });
        }
        catch (err) {
            return;
        }
        if (data) {
            store.writeQuery({
                query: groceryItems_1.groceryItemsQuery,
                data: {
                    __typename: "Query",
                    groceryItems: {
                        __typename: "GroceryItemsResponse",
                        items: data.groceryItems.items.filter(gi => gi.id !== variables.id),
                        recipes: data.groceryItems.recipes,
                    },
                },
            });
        }
    },
});
//# sourceMappingURL=DeleteGroceryItem.js.map